import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { FormField } from "@tellescope/types-models";
import { isBookingBlockedByEligibility } from "../../utils";
import { TellescopeFieldResponse } from "../../types";
import type { LocalTellescopeFormResponseMap } from "./use-tellescope-form-core";

export interface IsFormCompleteArgs {
  visibleFields: (FormField & { answer: TellescopeFieldResponse["answer"] })[];
  fieldsMap: Record<string, TellescopeModelFromName<"form_fields">> | undefined;
  currentResponses: LocalTellescopeFormResponseMap;
  validate: (fieldId: string) => string | null;
}

/**
 * Whether every visible field that needs an answer currently validates. Emptiness, signature
 * consent, and Question Group sub-field rules all live inside `validate`.
 */
export const isFormComplete = ({
  visibleFields,
  fieldsMap,
  currentResponses,
  validate,
}: IsFormCompleteArgs): boolean => {
  const responsesArray = Object.values(currentResponses);

  return visibleFields.every((field) => {
    const fieldMetadata = fieldsMap?.[field.id];
    if (!fieldMetadata) return false;

    if (fieldMetadata.isOptional) return true;

    if (isBookingBlockedByEligibility(fieldMetadata, responsesArray)) return true;

    return validate(field.id) === null;
  });
};
